// Components==============
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
// =========================

const getQuestionnaireById = async (id: string) => {
    const { data } = await axios.get(`/questionnaire/id/${id}`);
    return data as QuestionnaireType;
};

export default function useGetQuestionnaireById(
    id: string,
    options?: UseQueryOptions<QuestionnaireType>,
) {
    const query = useQuery<QuestionnaireType>({
        queryKey: ["questionnaireById"],
        queryFn: () => getQuestionnaireById(id),
        ...options,
    });

    return query;
}
